import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Dataset, DatasetStats } from '../models/dataset.model';

@Injectable({
  providedIn: 'root'
})
export class DatasetService {
  private readonly apiUrl = environment.apiUrl;
  private readonly datasetsEndpoint = environment.apiEndpoints.datasets;

  constructor(private http: HttpClient) {}

  getDatasets(): Observable<Dataset[]> {
    return this.http.get<Dataset[]>(`${this.apiUrl}${this.datasetsEndpoint}`);
  }

  getDataset(id: string): Observable<Dataset> {
    return this.http.get<Dataset>(`${this.apiUrl}${this.datasetsEndpoint}/${id}`);
  }

  // Public endpoint for unauthenticated access (used by public chat)
  getPublicDataset(id: string): Observable<Dataset> {
    return this.http.get<Dataset>(`${this.apiUrl}/public/datasets/${id}`);
  }

  getDatasetStats(id: string): Observable<DatasetStats> {
    return this.http.get<DatasetStats>(`${this.apiUrl}${this.datasetsEndpoint}/${id}/stats`);
  }
} 